import { useState } from "react";
import ContainerSize from "../container";
import PopUp from "../pop-up";

const ServicesContent = ({ servicesCardData }) => {
    const [servicesData, setServicesData] = useState(null);
    const [showToogle, setShowToogle] = useState(false);

    const handelIndexing = (data) => {
        setServicesData(data);
        setShowToogle(true);
    };

    const handleClosePopup = () => {
        setShowToogle(false);
    };
    return (<>
        <div className="bg-gray-200 p-6">
            <ContainerSize>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6  md:p-10 ">
                    {servicesCardData.map((items, index) => (

                        <div key={index} className="bg-white h-[300px] rounded-xl">
                            <div className="flex items-center justify-center h-[70px] px-2 bg-blue-300 text-semiHeading rounded-t-xl">
                                <h3 className="text-center leading-tight">
                                    {items.heading}
                                </h3>
                            </div>

                            <div className="h-[200px] py-5 px-4">
                                <p className="overflow-hidden text-ellipsis whitespace-normal [display:-webkit-box] [-webkit-line-clamp:3] [-webkit-box-orient:vertical]">
                                    {items.descriptions.trim()}
                                </p>
                              

                                <button className="pt-9 text-orange-500 font-bold text-[17px] cursor-pointer" onClick={() => handelIndexing(items)}>Read More ....</button>
                            </div>
                        </div>
                    ))}
                </div>
            </ContainerSize>
            {servicesData && (
                <PopUp
                    data={servicesData}
                    showToogle={showToogle}
                    onClose={handleClosePopup}
                />
            )}
        </div>
    </>)





}
export default ServicesContent